module.exports = __webpack_public_path__ + "statics/img/2-6.77d4418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-6.png
// module id = o2zl
// module chunks = 1